<template>
  <transition appear name="fade">
    <div
      class="fixed bottom-0 left-0 right-0 overflow-hidden z-50 w-full bg-grey-0 p-6 flex flex-col sm:flex-row justify-between border-t border-blue-7 text-base text-grey-9"
      v-if="isOpen"
    >
      <div
        class="mr-0 sm:mr-2 mb-2 sm:mb-0 text-base overflow-auto w-full flex-1 flex items-center"
      >
        <div>
          We use cookies to ensure you get the best experience on our website.
          <a
            href="https://cookiesandyou.com/"
            target="_blank"
            class="underline text-grey-7 hover:text-blue-7"
          >Learn More...</a>
        </div>
      </div>

      <div>
        <button
          @click="decline"
          class="block sm:inline-block my-2 sm:my-0 w-full sm:w-auto mx-2 border border-grey-9 text-sm bg-grey-1 px-2 py-1 rounded transition-colors transition-250 text-red-8 hover:bg-grey-2 hover:text-red-7 hover:border-red-7"
        >Opt Out</button>
        <button
          @click="accept"
          class="block sm:inline-block w-full sm:w-auto my-2 sm:my-0 mx-2 border border-grey-9 text-sm bg-grey-1 px-2 py-1 rounded transition-colors transition-250 text-green-8 hover:bg-grey-2 hover:text-green-7 hover:border-green-7"
        >Accept</button>
      </div>
    </div>
  </transition>
</template>

<script>
import * as tinyCookie from "tiny-cookie"
import cookies from "@/cookies"

export default {
  name: "Cookie",
  data() {
    return {
      status: null,
      supportsLocalStorage: true,
      isOpen: false
    }
  },
  mounted() {
    this.checkLocalStorageFunctionality()
    this.init()
  },
  methods: {
    init() {
      let visitedType = cookies.getCookieStatus()
      if (
        visitedType &&
        (visitedType === "accept" || visitedType === "decline")
      ) {
        this.isOpen = false
      }

      if (!visitedType) {
        this.isOpen = true
      }

      this.status = visitedType
      this.$emit("status", visitedType)
    },
    checkLocalStorageFunctionality() {
      this.supportsLocalStorage = cookies.checkLocalStorage()
    },
    setCookieStatus(type) {
      if (this.supportsLocalStorage) {
        if (type === "accept") {
          localStorage.setItem(`cookie-accept`, "accept")
        }
        if (type === "decline") {
          localStorage.setItem(`cookie-accept`, "decline")
        }
      } else {
        if (type === "accept") {
          tinyCookie.set(`cookie-accept`, "accept")
        }
        if (type === "decline") {
          tinyCookie.set(`cookie-accept`, "decline")
        }
      }
    },
    accept() {
      this.setCookieStatus("accept")
      this.status = "accept"
      this.isOpen = false
      this.$emit("clicked-accept")
    },
    decline() {
      this.setCookieStatus("decline")
      this.status = "decline"
      this.isOpen = false
      this.$emit("clicked-decline")
    },
    removeCookie() {
      localStorage.removeItem(`cookie-accept`)
      this.status = null
      this.$emit("removed-cookie")
    }
  }
}
</script>
